module.exports = __webpack_public_path__ + "media/images/restaurant/logo_visa-b27d6af0f128730eb73203556c654d56.png";